<div class="transport-details-list-entry">
  <div class="information">
    <div class="info-button">
      <app-transport-details-dialog-action [transport]="transport.transport" [asButton]="true"
        (onChange)="triggerUsageRefresh()" [dashboardContext]="dashboardContext"></app-transport-details-dialog-action>
      <!-- <button mat-stroked-button (click)="showTransportInfos()"><sc-icon iconClass="fa-info"></i></button> -->
    </div>
    <div class="row" *ngIf="transport">
      <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition"
        [transport]="transport.transport">
      </app-transport-details>
    </div>
  </div>

  <div class="actions">
    <ng-container *ngFor="let mk of transport.messageKeys">
      <div class="notification">
        <sc-dictionary-label [dictionaryKey]="mk"></sc-dictionary-label>
      </div>
    </ng-container>
    <div class="notification"
      *ngIf="featureUmbrueckungEnabled && transport.completeUmbrueckungAllowed && transport.completeUmbrueckungEnabled">
      <div [innerHTML]="'the trailer of the selected transport of currently beeing swapped, you can cancel or complete this process.' | translate: ['tmc-yard.ui.control.sac-client.complete-umbrueckung-dialog.info-text', translationService.language, translationService.revision] |
      trustHtml">
      </div>
    </div>
    <sc-flex *ngIf="transport.assignAllowed">
      <sc-button primary (click)="assignTransportToStation()" class="grow"
        dictionaryKey="tmc-yard.ui.control.sac-client.transport-details-list-entry.action.assign"></sc-button>
    </sc-flex>
    <ng-container *ngIf="featureMovingOrderActive">
      <div class="action-bar" *ngIf="transport.createMovementOrderAllowed">
        <sc-button mat-flat-button (click)="createMovementOrder()"
          dictionaryKey="tmc-yard.ui.control.sac-client.transport-details-list-entry.action.create-moving-order"></sc-button>
      </div>
    </ng-container>
    <div class="action-bar"
      *ngIf="station?.stationUsage?.plannedTransportAssignmentPossible && station?.stationUsage?.transports.length>0 && !transport.plannedForAssignment">
      <sc-button mat-flat-button (click)="planAssignment()"
        dictionaryKey="tmc-yard.ui.control.sac-client.transport-details-list-entry.action.plan-assignment">
      </sc-button>
    </div>
    <ng-container *ngIf="featureUmbrueckungEnabled">
      <div class="action-bar" *ngIf="transport.startUmbrueckungAllowed">
        <sc-button mat-flat-button (click)="startUmbrueckung()" [disabled]="!transport.startUmbrueckungEnabled"
          dictionaryKey="tmc-yard.ui.control.sac-client.transport-details-list-entry.action.start-umbrueckung">
        </sc-button>
      </div>
      <div class="action-bar" *ngIf="transport.completeUmbrueckungAllowed">
        <sc-button mat-stroked-button (click)="cancelUmbrueckung()" [disabled]="!transport.completeUmbrueckungEnabled"
          dictionaryKey="tmc-yard.ui.control.sac-client.transport-details-list-entry.action.cancel-umbrueckung">
        </sc-button>
        <div class="spacer"></div>
        <sc-button mat-flat-button (click)="completeUmbrueckung()" [disabled]="!transport.completeUmbrueckungEnabled"
          dictionaryKey="tmc-yard.common.action.finish">
        </sc-button>
      </div>
    </ng-container>
  </div>
</div>
